var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6914 7.63636C14.7923 7.63636 17.5578 9.37909 18.9078 12.1364C17.5578 14.8936 14.7923 16.6364 11.6914 16.6364C8.5905 16.6364 5.82504 14.8936 4.47504 12.1364C5.82504 9.37909 8.5905 7.63636 11.6914 7.63636ZM11.6914 6C7.6005 6 4.10686 8.54455 2.69141 12.1364C4.10686 15.7282 7.6005 18.2727 11.6914 18.2727C15.7823 18.2727 19.276 15.7282 20.6914 12.1364C19.276 8.54455 15.7823 6 11.6914 6ZM11.6914 10.0909C12.8205 10.0909 13.7369 11.0073 13.7369 12.1364C13.7369 13.2655 12.8205 14.1818 11.6914 14.1818C10.5623 14.1818 9.64595 13.2655 9.64595 12.1364C9.64595 11.0073 10.5623 10.0909 11.6914 10.0909ZM11.6914 8.45455C9.66232 8.45455 8.00959 10.1073 8.00959 12.1364C8.00959 14.1655 9.66232 15.8182 11.6914 15.8182C13.7205 15.8182 15.3732 14.1655 15.3732 12.1364C15.3732 10.1073 13.7205 8.45455 11.6914 8.45455Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOn);
export default __webpack_public_path__ + "static/media/visibility-on.82483499dc87751b0ed7d896ab9add8b.svg";
export { ForwardRef as ReactComponent };